import React, { Suspense, useState, useEffect } from 'react';
import { shouldRenderDirectBookInDrawer } from 'Common/config';
import { useSchedulingModule } from '../module-federation/scheduling-ui';

/**
 * Component for loading direct book from the independently deployed scheduling-ui MFE
 */
function DirectBookingMFE({
  productName,
  searchSummary,
  onScroll,
  location,
  match,
  config,
  history,
  appSettings
}) {
  const [isClient, setIsClient] = useState(false);

  const SchedulingUiMFE = useSchedulingModule({
    url: appSettings.MICRO_FRONT_ENDS.SCHEDULING_UI,
    moduleName: 'KyruusSchedulingUI'
  });

  useEffect(() => {
    setIsClient(true);
  }, []);

  // skip server side rendering
  if (!isClient) {
    return null;
  }

  /**
   * Set some business logic pulled from `direct-booking.jsx` this is to maintain
   * the same behaviors between the two components
   */

  // Check if we are using react-router client-side modal routing
  const isClientSideModalRouting =
    location?.state?.provider?.provider?.id != null;

  /* DBW can be configured to render within a drawer.
  Do not render DBW if the required parameters are not provided. */
  if (
    !isClient ||
    (shouldRenderDirectBookInDrawer(config) && !isClientSideModalRouting)
  ) {
    return null;
  }

  /*
    If using react-router client-side modal routing, use the provider ID from the location state.
    Otherwise, use the value from the URL params.
  */
  const providerId = isClientSideModalRouting
    ? location.state.provider.provider.id
    : match.params.providerId;

  return (
    <Suspense fallback={<div className="loader">Loading...</div>}>
      <SchedulingUiMFE
        providerId={providerId}
        productName={productName}
        apiBaseURL="/"
        searchSummary={searchSummary}
        onScroll={onScroll}
        history={history}
      />
    </Suspense>
  );
}

export default DirectBookingMFE;
